module.exports = __webpack_public_path__ + "static/img/teBuContent7.df50865.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teBuContent7.png
// module id = Ay9r
// module chunks = 2